import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'ff-fileinput-progress-bar',
  templateUrl: './fileinput-progress-bar.component.html',
  styleUrls: ['./fileinput-progress-bar.component.scss']
})
export class FileinputProgressBarComponent implements OnInit {
  @Input() progress = 0;
  constructor() { }

  ngOnInit(): void {
  }

}
